<template>
  <el-dialog title="传包" :visible.sync="uploaddialogVisible" :show-close="false" width="770px">
    <div class="upload">
      <div class="title">游戏传包</div>
      <p>填入之前请确认包体是否已接入好，有问题请<el-link type="primary">联系我们</el-link></p>

      <div class="upload-info" v-if="uploadData.platform === 1 || uploadData.accessType === 1">
        <p>应用下载包名：</p>
        <el-input v-model="packagePath" placeholder="请输入下载包名" maxlength="100"></el-input>
      </div>
      <div v-if="uploadData.platform === 1 || uploadData.accessType === 1">
        <el-radio-group v-model="loadType">
          <el-radio :label="1">包体链接上传</el-radio>
          <el-radio :label="2">本地文件上传</el-radio>
        </el-radio-group>
        <el-input v-model="downPackPath" placeholder="请输入包体链接" v-if="loadType === 1"></el-input>
        <el-upload
          v-if="loadType === 2"
          class="avatar-uploader"
          :action="uploadUrl"
          :show-file-list="false"
          :on-success="handleSuccess"
          :with-credentials="true"
          :before-upload="beforeUpload"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <p class="fileName">{{ fileName }}</p>
        <p v-if="uploadData.uploadState === 1 && (packagePath.length || fileName.length)">是否覆盖上一个应用包？</p>
      </div>
      <div v-else>
        <el-input v-model="downPackPath" placeholder="请输入包体链接"></el-input>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="publichandleClose">退 出</el-button>
      <el-button type="primary" @click="submit" :loading="submitLoading" :disabled="andriodDisabled || iosDisabled">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { HOST_API } from '@/api/config'
import { uploadParentPackage, uploadChannelPackage } from '@/api/sysmana.model'
export default {
  name: 'uploadDialog',
  props: {
    isShowDialog: {
      type: Boolean,
      required: true
    },
    uploadData: {
      type: Object,
      required: true,
      default: () => {}
    },
    pageType: {
      type: String,
      required: true
    },
    gameId: {
      type: Number
    }
  },
  data() {
    return {
      packagePath: '',
      loadType: 1,
      uploadUrl: HOST_API + '/api/ptom/aggregation/uploadAppImage',
      downPackPath: '',
      fileName: '',
      apkFile: '',
      file: '',
      submitLoading: false
    }
  },
  computed: {
    uploaddialogVisible: {
      get() {
        return this.isShowDialog
      },
      set(val) {
        this.$emit('update:isShowDialog', val)
      }
    },
    andriodDisabled() {
      return (
        (this.uploadData.platform === 1 || !this.uploadData.platform) &&
        (!this.packagePath.length || (this.loadType === 1 && !this.downPackPath.length) || (this.loadType === 2 && !this.fileName.length))
      )
    },
    iosDisabled() {
      return this.uploadData.platform === 2 && !this.downPackPath.length
    }
  },
  created() {},
  methods: {
    handleSuccess(res, file) {
      if (res.code !== 200) {
        this.$message.error(res.msg)
      }
      this.fileName = res.data
      this.apkFile = file
    },
    beforeUpload(file) {
      if (this.pageType === 'polymerization' || (this.pageType === 'comprehensive' && this.uploadData.accessType === 2)) {
        this.fileName = file.name
        this.apkFile = file
        return false
      } else {
        const isLt10M = file.size / 1024 / 1024 < 2000
        if (!isLt10M) {
          this.$message.error('上传文件大小不能超过 2000MB!')
        }
        return isLt10M
      }
    },
    publichandleClose() {
      this.publicClose()
    },

    submit() {
      const tGameVo = {
        gameId: this.uploadData.gameId,
        downPackPath: this.downPackPath,
        packagePath: this.packagePath,
        loadType: this.loadType,
        tmpPackagePath: this.fileName ? this.fileName.split('tmp/')[1] : ''
      }

      if (this.pageType === 'comprehensive' && this.uploadData.accessType === 1) {
        // 综合传包母包
        this.submitLoading = true
        uploadParentPackage(tGameVo).then((data) => {
          this.submitLoading = false
          if (data) {
            this.publicClose()
            this.$parent.getData()
            this.$message.success('上传成功')
          }
        })
      } else {
        // 聚合渠道传包母包
        const fd = new FormData()
        const { gameId, devGameId, channelId, id, accessType, platform } = this.uploadData
        fd.append('gameId', gameId)
        fd.append('devGameId', devGameId)
        fd.append('channelId', channelId)
        fd.append('id', id)
        fd.append('downPackPath', this.downPackPath)
        fd.append('packagePath', this.packagePath)
        fd.append('loadType', this.loadType)
        fd.append('accessType', accessType)
        fd.append('platform', platform)
        fd.append('apkFile', this.apkFile)
        this.submitLoading = true
        uploadChannelPackage(fd).then((data) => {
          this.submitLoading = false
          if (data) {
            this.publicClose()
            this.$message.success('上传成功')
            if (this.pageType === 'polymerization') {
              this.$parent.getAppByPage(this.gameId)
            }
            if (this.pageType === 'comprehensive') {
              this.$parent.getData()
            }
          }
        })
      }
    },
    publicClose() {
      this.packagePath = ''
      this.downPackPath = ''
      this.fileName = ''
      this.$emit('closeUploadDialog', false)
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.el-dialog__body) {
  padding: 0 20px;
}
:deep(.avatar-uploader) {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409eff;
  }
}
.fileName {
  margin: 0 0 0 10px;
  line-height: 25px;
  vertical-align: top;
}
:deep(.avatar-uploader-icon) {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.avatar {
  width: 60px;
  height: 60px;
  display: block;
}
.el-radio-group {
  margin: 10px 0;
}
.upload {
  .title {
    line-height: 30px;
  }
  p {
    line-height: 25px;
  }
}
</style>
